export default __webpack_public_path__ + "static/media/sazman.97840505.png";